import React from 'react'
import { StyleSheet } from 'react-native';
import { DNABox, Iffy } from '@alucio/lux-ui'
import { ReportProvider } from 'src/components/Reports/ReportProvider';
import { ReportSelector } from 'src/components/Reports/ReportSelector';
import useFeatureFlags from 'src/hooks/useFeatureFlags/useFeatureFlags';
import WrapperReport from 'src/components/Reports/WrapperReport';
import { TitleBar } from 'src/components/DNA';

const styles = StyleSheet.create({
  header: {
    marginBottom: 0,
  },
  iFrame: {
    border: '1px solid rgba(0, 0, 0, 0.1)',
    borderRadius: 10,
  },
});

const publisherFolder = 'Beacon_Embedded_Publisher'
const FIGMA_ANALYTICS_DEMO_URL = 'https://embed.figma.com/proto/Euo76my4iCPmlWBh5kpcyp/Analytics?page-id=786%3A15789&' +
  'node-id=2730-4106&node-type=canvas&viewport=911%2C2923%2C0.53&scaling=min-zoom&content-scaling=fixed&' +
  'starting-point-node-id=2730%3A4106&hide-ui=1&embed-host=share';

const PublisherReports = () => {
  const enableDemoMode = useFeatureFlags('enableDemoMode');

  return (
    <ReportProvider folderName={publisherFolder}>
      <DNABox
        spacing="md"
        appearance="col"
        fill={!enableDemoMode}
      >
        { /* HEADER */}
        <TitleBar title="Analytics" description="Track performance and uncover actionable insights" />
        <Iffy is ={!enableDemoMode}>
          <ReportSelector />
          <DNABox fill>
            <WrapperReport />
          </DNABox>
        </Iffy>
        <Iffy is={enableDemoMode}>
          <DNABox fill>
            <iframe
              style={styles.iFrame}
              width="1240"
              height="1819"
              src={FIGMA_ANALYTICS_DEMO_URL}
              allowFullScreen
            />
          </DNABox>
        </Iffy>
      </DNABox>
    </ReportProvider >
  )
}

PublisherReports.displayName = 'Reports';

export default PublisherReports
